(function () {
  'use strict';

  angular.module('datepicker').directive('datepicker', datepicker);

  datepicker.$inject = ['$timeout'];

  function datepicker($timeout) {
    var directive = {
      controller: 'DatepickerCtrl',
      controllerAs: 'vm',
      template: require('../datepicker/datepicker.html'),
      link: link,
      restrict: 'AE',
      scope: {
        unavailable: '=?',
        onlyFutureDates: '=?',
      },
    };
    return directive;

    function link(scope, element, attrs) {
      $timeout(function () {
        $(element).datepicker({
          dateFormat: 'yy-mm-dd',
          showOtherMonths: true,
          firstDay: 1,
          minDate: scope.onlyFutureDates ? '+1D' : null,
          beforeShowDay: scope.unavailable ? unavailable : null,
        });
      }, 100);

      function unavailable(date) {
        var ymd =
          date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate();
        if ($.inArray(ymd, scope.unavailable) == -1) {
          return [true, ''];
        } else {
          return [false, '', 'Unavailable'];
        }
      }
    }
  }
})();
